import { render, staticRenderFns } from "./GraphMatchCard.vue?vue&type=template&id=5cfe4192&scoped=true&"
import script from "./GraphMatchCard.vue?vue&type=script&lang=js&"
export * from "./GraphMatchCard.vue?vue&type=script&lang=js&"
import style0 from "./GraphMatchCard.vue?vue&type=style&index=0&id=5cfe4192&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe4192",
  null
  
)

export default component.exports